import {
  ChartCard,
  ChartNoDataFound,
  placeholder,
  useEffect,
  useState,
} from "@";
import { useDriversVerificationsQuery } from "../utils/queries.js";

const Drivers = () => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Use React Query to fetch drivers verifications data
  const { data: driversData } = useDriversVerificationsQuery(searchDuration);

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (driversData?.driversResponseViewModels) {
      setData(driversData.driversResponseViewModels);
    }
  }, [driversData]);

  return (
    <>
      <ChartCard
        title="المناديب "
        searchDurationUpdated={fetchData}
        searchDuration={searchDuration}
      >
        {data?.length > 0 ? (
          <div className="relative mt-3 overflow-x-auto">
            <table className="w-full text-sm text-gray-500 dark:text-gray-400">
              <thead className="border-b border-gray-100 text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-3 py-3"></th>
                  <th scope="col" className="px-1 py-3 text-center">
                    الطلبات الموصلة
                  </th>
                  <th scope="col" className="px-1 py-3 text-center">
                    الطلبات المعاده
                  </th>
                  <th scope="col" className="px-1 py-3 text-center">
                    الطلبات في انتظار الموافقة
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((driver, i) => (
                  <tr key={i} className="text-gray-500 dark:text-gray-400">
                    <th className="px-3 py-2">
                      <div className="flex items-center justify-start">
                        <img
                          alt={driver.displayName}
                          src={placeholder}
                          className="h-12 w-12 rounded-full object-cover"
                        />
                        <h3 className="ms-2 text-sm dark:text-gray-400">
                          {driver.displayName}
                        </h3>
                      </div>
                    </th>

                    <th className="px-1 py-2 text-center">
                      {driver.totalDeliveredVerifications}
                    </th>
                    <th className="px-1 py-2 text-center">
                      {driver.totalRejectedVerifications}
                    </th>
                    <th className="px-1 py-2 text-center">
                      {driver.totalPendingVerifications}
                    </th>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="h-80">
            <ChartNoDataFound />
          </div>
        )}
      </ChartCard>
    </>
  );
};

export default Drivers;
